const data = `Date,Open,High,Low,Close,Adj Close,Volume
2021-03-05,120.980003,121.940002,117.570000,121.419998,120.702599,153766600
2021-03-08,120.930000,121.000000,116.209999,116.360001,115.672493,154376600
2021-03-09,119.029999,122.059998,118.790001,121.089996,120.374550,129525800
2021-03-10,121.690002,122.169998,119.449997,119.980003,119.271111,111943300
2021-03-11,122.540001,123.209999,121.260002,121.959999,121.239418,103026500
2021-03-12,120.400002,121.169998,119.160004,121.029999,120.314896,88105100
2021-03-15,121.410004,124.000000,120.419998,123.989998,123.257416,92403800
2021-03-16,125.699997,127.220001,124.720001,125.570000,124.828079,115227900
2021-03-17,124.050003,125.860001,122.339996,124.760002,124.022873,111932600
2021-03-18,122.879997,123.180000,120.320000,120.529999,119.817856,121229700
2021-03-19,119.900002,121.430000,119.680000,119.989998,119.281052,185549500
2021-03-22,120.330002,123.870003,120.260002,123.389999,122.660965,111912300
2021-03-23,123.330002,124.239998,122.139999,122.540001,121.815979,95467100
2021-03-24,122.820000,122.900002,120.070000,120.089996,119.380455,88530500
2021-03-25,119.540001,121.660004,119.000000,120.589996,119.877495,98844700
2021-03-26,120.349998,121.480003,118.919998,121.209999,120.493835,94071200
2021-03-29,121.650002,122.580002,120.730003,121.389999,120.672775,80819200
2021-03-30,120.110001,120.400002,118.860001,119.900002,119.191582,85671900
2021-03-31,121.650002,123.519997,121.150002,122.150002,121.428291,118323800
2021-04-01,123.660004,124.180000,122.489998,123.000000,122.273262,75089100
2021-04-05,123.870003,126.160004,123.070000,125.900002,125.156143,88651200
2021-04-06,126.500000,127.129997,125.650002,126.209999,125.464302,80171300
2021-04-07,125.830002,127.919998,125.139999,127.900002,127.144325,83466700
2021-04-08,128.949997,130.389999,128.520004,130.360001,129.589783,88844600
2021-04-09,129.800003,133.039993,129.470001,133.000000,132.214172,106686700
2021-04-12,132.520004,132.850006,130.630005,131.240005,130.464600,91420000
2021-04-13,132.440002,134.660004,131.929993,134.429993,133.635742,91266500
2021-04-14,134.940002,135.000000,131.660004,132.029999,131.249908,87222800
2021-04-15,133.820007,135.000000,133.639999,134.500000,133.705322,89347100
2021-04-16,134.300003,134.669998,133.279999,134.160004,133.367340,84922400
2021-04-19,133.509995,135.470001,133.339996,134.839996,134.043320,94264200
2021-04-20,135.020004,135.529999,131.809998,133.110001,132.323532,94812300
2021-04-21,132.360001,133.750000,131.300003,133.500000,132.711227,68847100
2021-04-22,133.039993,134.149994,131.410004,131.940002,131.160461,84566500
2021-04-23,132.160004,135.119995,132.160004,134.320007,133.526382,78657500
2021-04-26,134.830002,135.059998,133.559998,134.720001,133.924026,66905100
2021-04-27,135.009995,135.410004,134.110001,134.389999,133.595978,66015800
2021-04-28,134.309998,135.020004,133.080002,133.580002,132.790756,107760100
2021-04-29,136.470001,137.070007,132.449997,133.479996,132.691345,151101000
2021-04-30,131.779999,133.559998,131.070007,131.460007,130.683289,109839500
2021-05-03,132.039993,134.070007,131.830002,132.539993,131.756882,75135100
2021-05-04,131.190002,131.490005,126.699997,127.849998,127.094612,137564700
2021-05-05,129.199997,130.449997,127.970001,128.100006,127.343140,84000900
2021-05-06,127.889999,129.750000,127.129997,129.740005,128.973450,78128300
2021-05-07,130.850006,131.259995,129.479996,130.210007,129.660538,78973300
2021-05-10,129.410004,129.539993,126.809998,126.849998,126.314713,88071200
2021-05-11,123.500000,126.269997,122.769997,125.910004,125.378685,126142800
2021-05-12,123.400002,124.639999,122.250000,122.769997,122.251930,112172300
2021-05-13,124.580002,126.150002,124.260002,124.970001,124.442650,105861300
2021-05-14,126.250000,127.889999,125.849998,127.449997,126.912170,81918000
2021-05-17,126.820000,126.930000,125.169998,126.269997,125.737152,74244600
2021-05-18,126.559998,126.989998,124.779999,124.849998,124.323151,63342900
2021-05-19,123.160004,124.919998,122.860001,124.690002,124.163826,92612000
2021-05-20,125.230003,127.720001,125.099998,127.309998,126.772774,76857100
2021-05-21,127.820000,128.000000,125.209999,125.430000,124.900703,79295400
2021-05-24,126.010002,127.940002,125.940002,127.099998,126.563660,63092900
2021-05-25,127.820000,128.320007,126.320000,126.900002,126.364502,72009500
2021-05-26,126.959999,127.389999,126.419998,126.849998,126.314713,56575900
2021-05-27,126.440002,127.639999,125.080002,125.279999,124.751335,94625600
2021-05-28,125.570000,125.800003,124.550003,124.610001,124.084167,71311100
2021-06-01,125.080002,125.349998,123.940002,124.279999,123.755562,67637100
2021-06-02,124.279999,125.239998,124.050003,125.059998,124.532265,59278900
2021-06-03,124.680000,124.849998,123.129997,123.540001,123.018684,76229200
2021-06-04,124.070000,126.160004,123.849998,125.889999,125.358765,75169300
2021-06-07,126.169998,126.320000,124.830002,125.900002,125.368721,71057600
2021-06-08,126.599998,128.460007,126.209999,126.739998,126.205177,74403800
2021-06-09,127.209999,127.750000,126.519997,127.129997,126.593529,56877900
2021-06-10,127.019997,128.190002,125.940002,126.110001,125.577835,71186400
2021-06-11,126.529999,127.440002,126.099998,127.349998,126.812599,53522400
2021-06-14,127.820000,130.539993,127.070000,130.479996,129.929382,96906500
2021-06-15,129.940002,130.600006,129.389999,129.639999,129.092926,62746300
2021-06-16,130.369995,130.889999,128.460007,130.149994,129.600784,91815000
2021-06-17,129.800003,132.550003,129.649994,131.789993,131.233856,96721700
2021-06-18,130.710007,131.509995,130.240005,130.460007,129.909485,108953300
2021-06-21,130.300003,132.410004,129.210007,132.300003,131.741714,79663300
2021-06-22,132.130005,134.080002,131.619995,133.979996,133.414612,74783600
2021-06-23,133.770004,134.320007,133.229996,133.699997,133.135818,60214200
2021-06-24,134.449997,134.639999,132.929993,133.410004,132.847031,68711000
2021-06-25,133.460007,133.889999,132.809998,133.110001,132.548309,70783700
2021-06-28,133.410004,135.250000,133.350006,134.779999,134.211243,62111300
2021-06-29,134.800003,136.490005,134.350006,136.330002,135.754700,64556100
2021-06-30,136.169998,137.410004,135.869995,136.960007,136.382065,63261400
2021-07-01,136.600006,137.330002,135.759995,137.270004,136.690750,52485800
2021-07-02,137.899994,140.000000,137.750000,139.960007,139.369400,78852600
2021-07-06,140.070007,143.149994,140.070007,142.020004,141.420700,108181800
2021-07-07,143.539993,144.889999,142.660004,144.570007,143.959946,104911600
2021-07-08,141.580002,144.059998,140.669998,143.240005,142.635544,105575500
2021-07-09,142.750000,145.649994,142.649994,145.110001,144.497665,99890800
2021-07-12,146.210007,146.320007,144.000000,144.500000,143.890228,76299700
2021-07-13,144.029999,147.460007,143.630005,145.639999,145.025421,100827100
2021-07-14,148.100006,149.570007,147.679993,149.149994,148.520599,127050800
2021-07-15,149.240005,150.000000,147.089996,148.479996,147.853439,106820300
2021-07-16,148.460007,149.759995,145.880005,146.389999,145.772247,93251400
2021-07-19,143.750000,144.070007,141.669998,142.449997,141.848877,121434600
2021-07-20,143.460007,147.100006,142.960007,146.149994,145.533264,96350000
2021-07-21,145.529999,146.130005,144.630005,145.399994,144.786423,74993500
2021-07-22,145.940002,148.199997,145.809998,146.800003,146.180511,77338200
2021-07-23,147.550003,148.720001,146.919998,148.559998,147.933090,71447400
2021-07-26,148.270004,149.830002,147.699997,148.990005,148.361282,72434100
2021-07-27,149.119995,149.210007,145.550003,146.770004,146.150650,104818600
2021-07-28,144.809998,146.970001,142.539993,144.979996,144.368195,118931200
2021-07-29,144.690002,146.550003,144.580002,145.639999,145.025421,56699500
2021-07-30,144.380005,146.330002,144.110001,145.860001,145.244492,70382000
2021-08-02,146.360001,146.949997,145.250000,145.520004,144.905945,62880000
2021-08-03,145.809998,148.039993,145.179993,147.360001,146.738159,64786600
2021-08-04,147.270004,147.789993,146.279999,146.949997,146.329895,56368300
2021-08-05,146.979996,147.839996,146.169998,147.059998,146.439438,46397700
2021-08-06,146.350006,147.110001,145.630005,146.139999,145.741333,54067400
2021-08-09,146.199997,146.699997,145.520004,146.089996,145.691467,48908700
2021-08-10,146.440002,147.710007,145.300003,145.600006,145.202820,69023100
2021-08-11,146.050003,146.720001,145.529999,145.860001,145.462097,48493500
2021-08-12,146.190002,149.050003,145.839996,148.889999,148.483841,72282600
2021-08-13,148.970001,149.440002,148.270004,149.100006,148.693283,59318800
2021-08-16,148.539993,151.190002,146.470001,151.119995,150.707748,103296000
2021-08-17,150.229996,151.679993,149.089996,150.190002,149.780304,92229700
2021-08-18,149.800003,150.720001,146.149994,146.360001,145.960739,86326000
2021-08-19,145.029999,148.000000,144.500000,146.699997,146.299805,86960300
2021-08-20,147.440002,148.500000,146.779999,148.190002,147.785751,59947400
2021-08-23,148.309998,150.190002,147.889999,149.710007,149.301620,60131800
2021-08-24,149.449997,150.860001,149.149994,149.619995,149.211838,48606400
2021-08-25,149.809998,150.320007,147.800003,148.360001,147.955276,58991300
2021-08-26,148.350006,149.119995,147.509995,147.539993,147.137512,48597200
2021-08-27,147.479996,148.750000,146.830002,148.600006,148.194641,55721500
2021-08-30,149.000000,153.490005,148.610001,153.119995,152.702301,90956700
2021-08-31,152.660004,152.800003,151.289993,151.830002,151.415817,86453100
2021-09-01,152.830002,154.979996,152.339996,152.509995,152.093964,80313700
2021-09-02,153.869995,154.720001,152.399994,153.649994,153.230850,71115500
2021-09-03,153.759995,154.630005,153.089996,154.300003,153.879089,57808700
2021-09-07,154.970001,157.259995,154.389999,156.690002,156.262573,82278300
2021-09-08,156.979996,157.039993,153.979996,155.110001,154.686874,74420200
2021-09-09,155.490005,156.110001,153.949997,154.070007,153.649719,57305700
2021-09-10,155.000000,155.479996,148.699997,148.970001,148.563614,140646400
2021-09-13,150.630005,151.419998,148.750000,149.550003,149.142044,102404300
2021-09-14,150.350006,151.070007,146.910004,148.119995,147.715927,109296300
2021-09-15,148.559998,149.440002,146.369995,149.029999,148.623444,83281300
2021-09-16,148.440002,148.970001,147.220001,148.789993,148.384094,68034100
2021-09-17,148.820007,148.820007,145.759995,146.059998,145.661560,129868800
2021-09-20,143.800003,144.839996,141.270004,142.940002,142.550079,123478900
2021-09-21,143.929993,144.600006,142.779999,143.429993,143.038727,75834000
2021-09-22,144.449997,146.429993,143.699997,145.850006,145.452133,76404300
2021-09-23,146.649994,147.080002,145.639999,146.830002,146.429474,64838200
2021-09-24,145.660004,147.470001,145.559998,146.919998,146.519211,53477900
2021-09-27,145.470001,145.960007,143.820007,145.369995,144.973434,74150700
2021-09-28,143.250000,144.750000,141.690002,141.910004,141.522873,108972300
2021-09-29,142.470001,144.449997,142.029999,142.830002,142.440384,74602000
2021-09-30,143.660004,144.380005,141.279999,141.500000,141.113998,88934200
2021-10-01,141.899994,142.919998,139.110001,142.649994,142.260864,94639600
2021-10-04,141.759995,142.210007,138.270004,139.139999,138.760437,98322000
2021-10-05,139.490005,142.240005,139.360001,141.110001,140.725067,80861100
2021-10-06,139.470001,142.149994,138.369995,142.000000,141.612640,83221100
2021-10-07,143.059998,144.220001,142.720001,143.289993,142.899109,61732700
2021-10-08,144.029999,144.179993,142.559998,142.899994,142.510178,58718700
2021-10-11,142.270004,144.809998,141.809998,142.809998,142.420425,64452200
2021-10-12,143.229996,143.250000,141.039993,141.509995,141.123978,73035900
2021-10-13,141.240005,141.399994,139.199997,140.910004,140.525620,78762700
2021-10-14,142.110001,143.880005,141.509995,143.759995,143.367828,69907100
2021-10-15,143.770004,144.899994,143.509995,144.839996,144.444885,67885200
2021-10-18,143.449997,146.839996,143.160004,146.550003,146.150223,85589200
2021-10-19,147.009995,149.169998,146.550003,148.759995,148.354187,76378900
2021-10-20,148.699997,149.750000,148.119995,149.259995,148.852829,58418800
2021-10-21,148.809998,149.639999,147.869995,149.479996,149.072220,61421000
2021-10-22,149.690002,150.179993,148.639999,148.690002,148.284393,58883400
2021-10-25,148.679993,149.369995,147.619995,148.639999,148.234528,50720600
2021-10-26,149.330002,150.839996,149.009995,149.320007,148.912674,60893400
2021-10-27,149.360001,149.729996,148.490005,148.850006,148.443954,56094900
2021-10-28,149.820007,153.169998,149.720001,152.570007,152.153809,100077900
2021-10-29,147.220001,149.940002,146.410004,149.800003,149.391357,124850400
2021-11-01,148.990005,149.699997,147.800003,148.960007,148.553650,74588300
2021-11-02,148.660004,151.570007,148.649994,150.020004,149.610764,69122000
2021-11-03,150.389999,151.970001,149.820007,151.490005,151.076767,54511500
2021-11-04,151.580002,152.429993,150.639999,150.960007,150.548203,60394600
2021-11-05,151.889999,152.199997,150.059998,151.279999,151.087509,65414600
2021-11-08,151.410004,151.570007,150.160004,150.440002,150.248581,55020900
2021-11-09,150.199997,151.429993,150.059998,150.809998,150.618103,56787900
2021-11-10,150.020004,150.130005,147.850006,147.919998,147.731781,65187100
2021-11-11,148.960007,149.429993,147.679993,147.869995,147.681839,41000000
2021-11-12,148.429993,150.399994,147.479996,149.990005,149.799149,63632600
2021-11-15,150.369995,151.880005,149.429993,150.000000,149.809128,59222800
2021-11-16,149.940002,151.490005,149.339996,151.000000,150.807861,59256200
2021-11-17,151.000000,155.000000,150.990005,153.490005,153.294693,88807000
2021-11-18,153.710007,158.669998,153.050003,157.869995,157.669113,137827700
2021-11-19,157.649994,161.020004,156.529999,160.550003,160.345718,117305600
2021-11-22,161.679993,165.699997,161.000000,161.020004,160.815109,117467900
2021-11-23,161.119995,161.800003,159.059998,161.410004,161.204620,96041900
2021-11-24,160.750000,162.139999,159.639999,161.940002,161.733948,69463600
2021-11-26,159.570007,160.449997,156.360001,156.809998,156.610474,76959800
2021-11-29,159.369995,161.190002,158.789993,160.240005,160.036102,88748200
2021-11-30,159.990005,165.520004,159.919998,165.300003,165.089676,174048100
2021-12-01,167.479996,170.300003,164.529999,164.770004,164.560349,152052500
2021-12-02,158.740005,164.199997,157.800003,163.759995,163.551620,136739200
2021-12-03,164.020004,164.960007,159.720001,161.839996,161.634064,117938300
2021-12-06,164.289993,167.880005,164.279999,165.320007,165.109650,107497000
2021-12-07,169.080002,171.580002,168.339996,171.179993,170.962173,120405400
2021-12-08,172.130005,175.960007,170.699997,175.080002,174.857224,116998900
2021-12-09,174.910004,176.750000,173.919998,174.559998,174.337875,108923700
2021-12-10,175.210007,179.630005,174.690002,179.449997,179.221664,115228100
2021-12-13,181.119995,182.130005,175.529999,175.740005,175.516388,153237000
2021-12-14,175.250000,177.740005,172.210007,174.330002,174.108185,139380400
2021-12-15,175.110001,179.500000,172.309998,179.300003,179.071854,131063300
2021-12-16,179.279999,181.139999,170.750000,172.259995,172.040802,150185800
2021-12-17,169.929993,173.470001,169.690002,171.139999,170.922241,195432700
2021-12-20,168.279999,170.580002,167.460007,169.750000,169.533997,107499100
2021-12-21,171.559998,173.199997,169.119995,172.990005,172.769882,91185900
2021-12-22,173.039993,175.860001,172.149994,175.639999,175.416504,92135300
2021-12-23,175.850006,176.850006,175.270004,176.279999,176.055695,68356600
2021-12-27,177.089996,180.419998,177.070007,180.330002,180.100540,74919600
2021-12-28,180.160004,181.330002,178.529999,179.289993,179.061859,79144300
2021-12-29,179.330002,180.630005,178.139999,179.380005,179.151749,62348900
2021-12-30,179.470001,180.570007,178.089996,178.199997,177.973251,59773000
2021-12-31,178.089996,179.229996,177.259995,177.570007,177.344055,64062300
2022-01-03,177.830002,182.880005,177.710007,182.009995,181.778397,104487900
2022-01-04,182.630005,182.940002,179.119995,179.699997,179.471344,99310400
2022-01-05,179.610001,180.169998,174.639999,174.919998,174.697418,94537600
2022-01-06,172.699997,175.300003,171.639999,172.000000,171.781143,96904000
2022-01-07,172.889999,174.139999,171.029999,172.169998,171.950928,86580100
2022-01-10,169.080002,172.500000,168.169998,172.190002,171.970901,106765600
2022-01-11,172.320007,175.179993,170.820007,175.080002,174.857224,76138300
2022-01-12,176.119995,177.179993,174.820007,175.529999,175.306641,74805200
2022-01-13,175.779999,176.619995,171.789993,172.190002,171.970901,84505800
2022-01-14,171.339996,173.779999,171.089996,173.070007,172.849792,80355000
2022-01-18,171.509995,172.539993,169.410004,169.800003,169.583939,90956700
2022-01-19,170.000000,171.080002,165.940002,166.229996,166.018478,94815000
2022-01-20,166.979996,169.679993,164.179993,164.509995,164.300659,91420500
2022-01-21,164.419998,166.330002,162.300003,162.410004,162.203354,122848900
2022-01-24,160.020004,162.300003,154.699997,161.619995,161.414337,162294600
2022-01-25,158.979996,162.759995,157.020004,159.779999,159.576691,115798400
2022-01-26,163.500000,164.389999,157.820007,159.690002,159.486801,108275300
2022-01-27,162.449997,163.839996,158.279999,159.220001,159.017410,121954600
2022-01-28,165.710007,170.350006,162.800003,170.330002,170.113266,179935700
2022-01-31,170.160004,175.000000,169.509995,174.779999,174.557602,115541600
2022-02-01,174.009995,174.839996,172.309998,174.610001,174.387817,86213900
2022-02-02,174.750000,175.880005,173.330002,175.839996,175.616257,84914300
2022-02-03,174.479996,176.240005,172.119995,172.899994,172.679993,89418100
2022-02-04,171.679993,174.100006,170.679993,172.389999,172.389999,82391400
2022-02-07,172.860001,173.949997,170.949997,171.660004,171.660004,77251200
2022-02-08,171.729996,175.350006,171.429993,174.830002,174.830002,74829200
2022-02-09,176.050003,176.649994,174.899994,176.279999,176.279999,71285000
2022-02-10,174.139999,175.479996,171.550003,172.119995,172.119995,90865900
2022-02-11,172.330002,173.080002,168.039993,168.639999,168.639999,98566000
2022-02-14,167.369995,169.580002,166.559998,168.880005,168.880005,86185500
2022-02-15,170.970001,172.949997,170.250000,172.789993,172.789993,62527400
2022-02-16,171.850006,173.339996,170.050003,172.550003,172.550003,61177400
2022-02-17,171.029999,171.910004,168.470001,168.880005,168.880005,69589300
2022-02-18,169.820007,170.539993,166.190002,167.300003,167.300003,82772700
2022-02-22,164.979996,166.690002,162.149994,164.320007,164.320007,91162800
2022-02-23,165.539993,166.149994,159.750000,160.070007,160.070007,90009200
2022-02-24,152.580002,162.850006,152.000000,162.740005,162.740005,141147500
2022-02-25,163.839996,165.119995,160.869995,164.850006,164.850006,91974200
2022-02-28,163.059998,165.419998,162.429993,165.119995,165.119995,94869100
2022-03-01,164.699997,166.600006,161.970001,163.199997,163.199997,83474400
2022-03-02,164.389999,167.360001,162.949997,166.559998,166.559998,79724800
2022-03-03,168.470001,168.910004,165.550003,166.229996,166.229996,76335600
2022-03-04,164.490005,165.550003,162.110001,163.169998,163.169998,83819592`;

export default data;
